import * as React from 'react';
import { MultipleBuildersModal, AgencyModal } from '@cian/frontend-newbuilding-sellers-info-components';
import { ActionLink, UIText1 } from '@cian/ui-kit';

import builderImg from './assets/builder.png';
import sellerImg from './assets/seller.png';
import * as styles from './ServiceBanner.css';
import { NBSP } from '../../constants/symbols';

export interface IServiceBannerProps {
  type: 'builder' | 'seller';
  onClick: () => void;
  isMultiSeller?: boolean;
}

export const ServiceBanner = ({ type, onClick, isMultiSeller }: IServiceBannerProps) => {
  const [serviceModalType, setServiceModalType] = React.useState<'builder' | 'seller' | null>(null);

  const onServiceModalClose = React.useCallback(() => {
    setServiceModalType(null);
  }, []);

  const onSellersBannerClick = React.useCallback(() => {
    setServiceModalType('seller');
    onClick();
  }, [onClick]);

  const onBuildersBannerClick = React.useCallback(() => {
    setServiceModalType('builder');
    onClick();
  }, [onClick]);

  return (
    <div className={styles['container']} data-testid="ServiceBanner">
      <img className={styles['image']} src={type === 'builder' ? builderImg : sellerImg} alt={type} />
      {type === 'builder' && (
        <div className={styles['description']}>
          <UIText1>В{NBSP}строительстве участвуют несколько компаний.</UIText1>{' '}
          <ActionLink fontWeight="bold" fontSize="M" onClick={onBuildersBannerClick}>
            Почему так бывает
          </ActionLink>
        </div>
      )}

      {type === 'seller' && (
        <div className={styles['description']}>
          <UIText1>
            Агентств{isMultiSeller ? 'а' : 'о'} недвижимости{NBSP}— по{NBSP}документам это{NBSP}первичная продажа, как
            {NBSP}у{NBSP}застройщика.
          </UIText1>
          <ActionLink fontWeight="bold" fontSize="M" onClick={onSellersBannerClick}>
            Как это работает
          </ActionLink>
        </div>
      )}

      <MultipleBuildersModal open={serviceModalType === 'builder'} onClose={onServiceModalClose} />
      <AgencyModal open={serviceModalType === 'seller'} onClose={onServiceModalClose} />
    </div>
  );
};
